"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledChargeNotificationType = exports.ScheduledChargeSnapshot = exports.ScheduledChargeNotificationMetadata = exports.ScheduledChargeNotificationContent = exports.ScheduledChargeNotification = void 0;
var scheduled_charges_entity_1 = require("./scheduled-charges.entity");
var ScheduledChargeNotification = /** @class */ (function () {
    function ScheduledChargeNotification() {
        this.propertyId = 0;
        this.leaseId = 0;
        this.applicationResponseId = '';
        this.notificationType = ScheduledChargeNotificationType.ChargeModified;
        this.suggestedContent = new ScheduledChargeNotificationContent();
        this.scheduledChargeData = new scheduled_charges_entity_1.ScheduledChargeGroup();
        this.changeDetails = [];
        this.metadata = new ScheduledChargeNotificationMetadata();
    }
    return ScheduledChargeNotification;
}());
exports.ScheduledChargeNotification = ScheduledChargeNotification;
var ScheduledChargeNotificationContent = /** @class */ (function () {
    function ScheduledChargeNotificationContent() {
        this.title = '';
        this.message = '';
    }
    return ScheduledChargeNotificationContent;
}());
exports.ScheduledChargeNotificationContent = ScheduledChargeNotificationContent;
var ScheduledChargeNotificationMetadata = /** @class */ (function () {
    function ScheduledChargeNotificationMetadata() {
        this.chargeName = '';
        this.currentAmount = '';
        this.changeType = '';
        this.affectedFields = [];
        this.hasAmountChange = false;
    }
    return ScheduledChargeNotificationMetadata;
}());
exports.ScheduledChargeNotificationMetadata = ScheduledChargeNotificationMetadata;
var ScheduledChargeSnapshot = /** @class */ (function () {
    function ScheduledChargeSnapshot() {
        this.id = '';
        this.applicationResponseId = '';
        this.propertyId = 0;
        this.leaseId = 0;
        this.chargesHash = '';
        this.chargesData = [];
        this.createdDate = new Date();
        this.updatedDate = new Date();
    }
    return ScheduledChargeSnapshot;
}());
exports.ScheduledChargeSnapshot = ScheduledChargeSnapshot;
var ScheduledChargeNotificationType;
(function (ScheduledChargeNotificationType) {
    ScheduledChargeNotificationType["ChargeModified"] = "ChargeModified";
})(ScheduledChargeNotificationType || (exports.ScheduledChargeNotificationType = ScheduledChargeNotificationType = {}));
